import { Box } from "@mui/material";
import React from "react";

const WHM_FILTER_GAP_PX = 20;

type Props = {
  children: React.ReactNode;
};

/** Three equal WHM filter columns with fixed gutters (Item Control + Inventory Reconciliation). */
const WhmFilterFieldsGrid: React.FC<Props> = ({ children }) => (
  <Box
    sx={{
      display: "grid",
      width: "100%",
      alignItems: "end",
      boxSizing: "border-box",
      gridTemplateColumns: {
        xs: "1fr",
        sm: "repeat(3, minmax(0, 1fr))",
      },
      gap: `${WHM_FILTER_GAP_PX}px`,
      "& > *": {
        minWidth: 0,
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      },
    }}
  >
    {children}
  </Box>
);

export default WhmFilterFieldsGrid;
